/**
 * Generated from @customerio/services-ui-api-openapi/contracts.json.
 * Do not edit directly.
 */
/** The people_searchable contract, as services validates filters against it. */
export const peopleSearchableSpec = {
    "contract": "people_searchable",
    "version": 1,
    "combinators": {
        "and": true,
        "or": true,
        "not": "any",
        "empty_groups": "reject",
        "max_depth": 8
    },
    "leaves": {
        "attribute": {
            "ops": {
                "email_valid": {
                    "values": "none",
                    "value_required": false,
                    "fields": [
                        "email"
                    ]
                },
                "eq": {
                    "values": "one",
                    "value_required": false,
                    "value_type": "string"
                },
                "exists": {
                    "values": "none",
                    "value_required": false
                },
                "one_of": {
                    "values": "list",
                    "value_required": true,
                    "value_type": "string",
                    "one_of": {
                        "max_values": 50,
                        "excluded_fields": [
                            "id",
                            "cio_id"
                        ],
                        "max_index_bytes": 180
                    }
                }
            },
            "inverse": true,
            "field_required": true,
            "field_names": "catalog"
        },
        "device_attribute": {
            "ops": {
                "eq": {
                    "values": "one",
                    "value_required": false,
                    "value_type": "string"
                },
                "exists": {
                    "values": "none",
                    "value_required": false
                }
            },
            "inverse": true,
            "field_required": true,
            "field_names": "catalog"
        },
        "named_bitmap": {
            "inverse": true
        },
        "newsletter_recipients": {
            "inverse": true
        },
        "seg_attr": {
            "inverse": false
        },
        "segment": {
            "inverse": true
        }
    }
};
//# sourceMappingURL=contract-specs.js.map